import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Gradient from 'modules/post/gradient.component';
import { getFavIcon, getTitle } from 'app/utils/post';
import UrlPreview from 'modules/createPost/mobile/urlPreview.component';
import { goToUrl } from 'modules/navigation/navigation.actions';
import PostTitle from './postTitle.component';
import { styled } from 'dripsy';
import { View, Image, Row, Pressable } from 'modules/styled';
import { View as RView } from 'react-native';

const GradientContainer = styled(RView)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
});

const TitleContainer = styled(RView)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
});

const IMAGE_HEIGHT = 30;
const PREVIEW_HEIGHT = 16;

ImagePost.propTypes = {
  noLink: PropTypes.bool,
  link: PropTypes.object,
  post: PropTypes.object,
  singlePost: PropTypes.bool,
  preview: PropTypes.bool,
  goToPost: PropTypes.func,
};

export default memo(ImagePost);

function ImagePost({ post, link, goToPost, preview, noLink, singlePost }) {
  const dispatch = useDispatch();

  if (!post) return null;

  const imageUrl = link?.image;
  const favIcon = link?.domain && getFavIcon(link.domain);
  const title = getTitle({ post, link });
  const image = imageUrl || favIcon;

  const imgBg = image && (
    <View sx={{ flex: 1 }}>
      <Image
        resizeMode="cover"
        sx={{ flexDirection: 'row', flex: 1, width: '100%' }}
        source={{ uri: image }}
      />
      <GradientContainer>
        <Gradient title={title} image={true} preview={preview} />
      </GradientContainer>
    </View>
  );

  const imageHeight = preview ? PREVIEW_HEIGHT : IMAGE_HEIGHT;

  if (preview) {
    return (
      <UrlPreview
        size="small"
        urlPreview={link || post}
        title={title}
        image={image}
        noLink={noLink}
      />
    );
  }

  return (
    <View>
      <Pressable
        onClick={goToPost || (() => dispatch(goToUrl(post.url)))}
        external
        to={post.url}
        target="_blank"
        noLink={noLink}
        sx={{ flex: 1 }}
      >
        <View sx={{ height: imageHeight * 8 }}>
          {imgBg || <Gradient flex={1} title={title} />}
        </View>
      </Pressable>

      <TitleContainer sx={{ flexDirection: 'row', p: 2, pt: 0, pl: preview ? 0 : 2 }}>
        <PostTitle
          post={post}
          link={link}
          noLink={noLink}
          title={title}
          preview={preview}
          singlePost={singlePost}
          mobile
        />
      </TitleContainer>
    </View>
  );
}
